import { Rule, User, UserFull } from '@wellesley/openapi'

import { REPORT_STEP } from '../ReportList/options'
import { NOT_FAN_ACTION } from '../NotFanReport/options'

export const INIT_OPTION = 'list'

export const DEFAULT_TITLE = 'What’s the issue with this post'

export type TReportModal = {
  user: User | UserFull
  isOpen: boolean
  groupId?: string | null
  targetReportEntityId: string
  onClose(): void
  removePosts(userId: string): void
}

export type ReportModalContentProps = Omit<TReportModal, 'removePosts'> & {
  groupRules: Rule[] | null
  selectedOption: REPORT_STEP | typeof INIT_OPTION
  onMute: (duration?: number) => void
  onBlock: () => void
  showSuccess(): void
  onSelectedOption: (option: REPORT_STEP) => void
  notFunAction: NOT_FAN_ACTION
  setNotFunAction: (action: NOT_FAN_ACTION) => void
}
